import { ViewType } from 'types';

export function __DateDifference({ dateString }: { dateString: string }) {
    const targetDate = new Date(dateString);
    const now = new Date();
    const diffInMs = targetDate.getTime() - now.getTime();
    const formattedDate = targetDate.toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    if (diffInMs > 0) {
        const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

        return `${formattedDate} (${diffInDays} روز)`;
    } else {
        return `${formattedDate} (منقضی شده)`;
    }
}

export function __GeneratePostViewPlot(views?: ViewType[]) {
    if (!views) return;
    const dates = views
        .map((view) => new Date(view.created_at).toLocaleDateString('fa').slice(2))
        .filter((item, i, ar) => ar.indexOf(item) === i);
    return dates.map((date) => ({
        date,
        count: views.filter((i) => new Date(i.created_at).toLocaleDateString('fa').slice(2)).length,
    }));
}
